import { Box, Button, Container, Typography } from '@mui/material';
import React from 'react';
import Logo from './components/Logo';

const colors = { primary: '#345784' };

export default function ChangePasswordSuccess({ navTo }) {
  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Logo />
      <Container sx={{ maxWidth: 428, textAlign: 'center' }}>
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 'bold',
            textTransform: 'uppercase',
            mb: 4,
            color: colors.primary,
          }}
        >
          Change Password
        </Typography>
        <Typography sx={{ mb: 4 }}>Your password was successfully updated.</Typography>
        <Button
          variant="contained"
          onClick={() => navTo('main.root')}
          sx={{ backgroundColor: colors.primary }}
        >
          Return to console
        </Button>
      </Container>
    </Box>
  );
}
